import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section className="py-20 bg-white text-center relative overflow-hidden border-t-8 border-gold-matte" data-id="element-121">
      <div className="max-w-3xl mx-auto px-6 md:px-12 relative z-10" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-123">
          <h2 className="text-4xl md:text-5xl font-extrabold text-coffee-dark mb-8 font-heading leading-tight" data-id="element-124">
            Tu próximo pedido puede estar más cerca de lo que creés
          </h2>

          <p className="text-xl md:text-2xl text-text-body mb-12 leading-relaxed font-medium" data-id="element-125">
            No necesitás tener todo perfecto. Necesitás un método, números
            claros y un plan de 30 días para pasar de la idea a la venta.
          </p>

          <div className="mb-8" data-id="element-126">
            <CTAButton size="large" fireAddToCart={true} onClick={() => window.location.href = window.open('https://cocinaproductiva.com/products/desayunos-sorpresa-rentables', '_blank')} className="text-xl md:text-2xl py-6 px-10" data-id="element-127">
              SÍ, QUIERO EL EBOOK + BONOS POR $14.999
            </CTAButton>
          </div>

          <p className="text-lg font-bold text-coffee-dark" data-id="element-128">
            <span className="line-through text-taupe-light mr-2" data-id="element-129">$60.999</span>{' '}
            $14.999 · Mercado Pago · 3 cuotas sin interés
          </p>
        </motion.div>
      </div>
    </section>;
}